var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      _c(
        "vxe-table",
        {
          ref: "fineTable",
          attrs: { "show-overflow": "", data: _vm.subjectList },
        },
        [
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "triggerAction",
              title: "扫码动作",
            },
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "amount", title: "奖励金额" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }